import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  body: {
    marginBottom: 27.91,
    [theme.breakpoints.down("sm")]: {
      marginBottom: "auto",
      paddingBottom: 40,
    },
  },
  selectList: {
    flexWrap: "wrap",
    width: 1000,
    marginTop: 90,
    marginBottom: 172,
    paddingLeft: 50,
    paddingRight: 50,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 80,
      paddingLeft: 60,
      paddingRight: 60,
    },
    [theme.breakpoints.down("md")]: {
      width: '100%',
      height: "auto",
      marginTop: 100,
      marginBottom: 0,
      paddingLeft: 150,
      paddingRight: 150,
      },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: 60,
      paddingLeft: 40,
      paddingRight: 40,
    },
  },
  cancerImg: {
    width: 180,
    height: 180,
    marginBottom: 33,
    [theme.breakpoints.down("md")]: {
      width: 180,
      height: 180,
      marginBottom: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 90,
      height: 90,
      marginBottom: 12,
    },
  },
  breastImg0: {
    backgroundImage: "url(/images/breast/section_illust_00.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    width: "100%",
    height: "100%",
    margin: "0 auto",
  },
  breastImg1: {
    backgroundImage: "url(/images/breast/section_illust_01.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    width: "100%",
    height: "100%",
    margin: "0 auto",
  },
  breastImg2: {
    backgroundImage: "url(/images/breast/section_illust_02.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    width: "100%",
    height: "100%",
    margin: "0 auto",
  },
  breastImg3: {
    backgroundImage: "url(/images/breast/section_illust_03.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    width: "100%",
    height: "100%",
    margin: "0 auto",
  },

  regular: {
    color: "#1a2633",
    fontWeight: 400,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  },
  regular2: {
    fontWeight: 400,
  },
  bold: {
    fontWeight: 500,
  },

  onImg: {
    borderRadius: "50%",
  },
  footer: {
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      bottom: theme.spacing(2),
    },
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      height: 56,
      fontSize: 18,
    },
  },
  item: {
    cursor: "pointer",
  },
  marginTp: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1.5),
    },
  },
  tems: {
    [theme.breakpoints.down("md")]: {
      marginBottom: 52,
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 30,
      width: "50%",
    },
  },
  large: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));

const ImgList = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.body}
    >
      <Grid
        container
        alignItems="center"
        justify="space-between"
        className={classes.selectList}
      >
        <Grid className={classes.tems}>
          <Grid
            container
            justify="center"
            direction="column"
            alignItems="center"
          >
            <div className={classes.cancerImg}>
              <div className={clsx(classes.breastImg0)}></div>
            </div>
            <Typography variant="h6" align="center">
              <span className={classes.regular}>발생위험도 계산</span>
            </Typography>
          </Grid>
        </Grid>        
        <Grid className={classes.tems}>
          <Grid
            container
            justify="center"
            direction="column"
            alignItems="center"
          >
            <div className={classes.cancerImg}>
              <div className={clsx(classes.breastImg1)}></div>
            </div>
            <Typography variant="h6" align="center">
              <span className={classes.regular}>유방암이란?</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid className={classes.tems}>
          <Grid
            container
            justify="center"
            direction="column"
            alignItems="center"
          >
            <div className={classes.cancerImg}>
              <div className={clsx(classes.breastImg2)}></div>
            </div>
            <Typography variant="h6" align="center">
              <span className={classes.regular}>유방암검진이란?</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid className={classes.tems}>
          <Grid
            container
            justify="center"
            direction="column"
            alignItems="center"
          >
            <div className={classes.cancerImg}>
              <div className={clsx(classes.breastImg3)}></div>
            </div>
            <Typography variant="h6" align="center">
              <span className={classes.regular}>이득과 부정적측면</span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ImgList;
